import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KatexServerRenderer {
  public constructor(private http: HttpClient) {}

  public async fetchAsciiMath(rootUrl: string, markup: string): Promise<string> {
    if (!markup) {
      return '';
    }

    if (this.isValidSyntax(markup)) {
      const url = `${rootUrl}/MathRenderer/ConvertMarkup`;
      const response = await firstValueFrom(this.http.post(url, { markup }, {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'text' }
      ));

      return response;
    }

    // if the number of backticks is odd or 0, then the syntax is invalid so just return the markup
    return markup;
  }

  private isValidSyntax(markup: string): boolean {
    const length = markup.split('`').length - 1;
    return length > 0 && length % 2 === 0;
  }
}
